import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loginUser } from '../../actions/authActions';
import classnames from 'classnames';
import './form.css';
import './utils.css';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

const Login = props => {
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState([]);
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (props.errors) {
      setErrors(props.errors);
      if (Object.keys(props.errors).length >= 1) {
        toast.error('Invalid login details provided', {
          // Set to 15sec
          position: toast.POSITION.TOP_CENTER,
          autoClose: 10000,
          limit :1
        });
      }
    }
  }, [props]);

  const onSubmit = e => {
    e.preventDefault();
    const userData = {
      email: email,
      password: password
    };

    props.loginUser(userData); // since we handle the redirect within our component, we don't need to pass in this.props.history as a parameter
  };


  const CustomButtonLogin = React.forwardRef(({ open, ...props }, ref) => (
    <div className="float-login-button">
      <button className="btn btn-success" ref={ref} {...props}>
        <i
          className="fa fa-sign-in"
          aria-hidden="true"
          style={{
            paddingRight: 7
          }}
        />{' '}
        Login
      </button>
    </div>
  ));

  return (
    <>
      {' '}
      {!props.auth.isAuthenticated && (
        <Popup
          trigger={open => <CustomButtonLogin open={open} />}
          modal
          nested
          contentStyle={{ width: '250px', borderRadius: 20 }}
        >
          {close => (
            <div className="container-login100">
              <div
                className="wrap-login100"
                style={{
                  background: 'linear-gradient( #7579ff, #b224ef)'
                }}
              >
                <form
                  className="login100-form validate-form"
                  onSubmit={onSubmit}
                >
                  <span className="login100-form-logo">
                    <i className="fa fa-home fa-2x" aria-hidden="true" />
                  </span>

                  <span className="login100-form-title p-b-34 p-t-27">
                    Log in{' '}
                  </span>

                  <div
                    className="wrap-input100 validate-input"
                    data-validate="Enter username"
                  >
                    <input
                      className={classnames('form-control  ', {
                        'is-invalid':
                          errors.email ||
                          errors.emailnotfound ||
                          errors.password ||
                          errors.passwordincorrect
                      })}
                      type="text"
                      placeholder="Email"
                      error={errors.email}
                      onChange={e => setEmail(e.target.value)}
                      value={email}
                    />
                  </div>

                  <div
                    className="wrap-input100 "
                    data-validate="Enter password"
                  >
                    <input
                      type="password"
                      placeholder="Password"
                      onChange={e => setPassword(e.target.value)}
                      value={password}
                      error={errors.password}
                      className={classnames('form-control ', {
                        'is-invalid':
                          errors.email ||
                          errors.emailnotfound ||
                          errors.password ||
                          errors.passwordincorrect
                      })}
                    />
                  </div>

                  <div className="container-login100-form-btn">
                    <button className="login100-form-btn">Login</button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </Popup>
      )}
    </>
  );
};

Login.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});
export default connect(
  mapStateToProps,
  { loginUser }
)(Login);
